// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2EadA","container":"styles_container__1pcCQ","title":"styles_title__2iXVd","wrapper":"styles_wrapper__3d6A3","answer":"styles_answer__k6NK4"};